import { render } from "./notice_view.vue?vue&type=template&id=b0990370"
import script from "./notice_view.vue?vue&type=script&lang=js"
export * from "./notice_view.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__